import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import consentCodePrefixApi from '@/features/dashboard/consentCodePrefix/api/consentCodePrefixApi.ts';
import { consentCodePrefixApiQueryKeys } from '@/features/dashboard/consentCodePrefix/api/consentCodePrefixApi.queryKeys.ts';
import { ConsentCodePrefixDto } from '@/features/dashboard/consentCodePrefix/types/ConsentCodePrefixDto.ts';

export default function useSetConsentCodePrefix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ConsentCodePrefixDto) => consentCodePrefixApi.set(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: consentCodePrefixApiQueryKeys.all(),
      });
      toast.success('Prefiks kodu zgody został zapisany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas zapisywania prefiksu kodu zgody.',
      });
    },
  });
}
